import { Snackbar, Alert, alpha } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import type { RootState } from '../store';
import { hideSnackbar } from '../store/snackbarSlice';

// Acento por severidad (success en emerald de marca).
const ACCENT: Record<string, string> = {
  success: '#10b981',
  error:   '#ef4444',
  warning: '#f59e0b',
  info:    '#3b82f6',
};

export function GlobalSnackbar() {
  const dispatch = useDispatch();
  const { open, message, severity } = useSelector((s: RootState) => s.snackbar);

  const accent = ACCENT[severity ?? 'info'] ?? ACCENT.info;

  return (
    <Snackbar
      open={open}
      autoHideDuration={4000}
      onClose={() => dispatch(hideSnackbar())}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert
        onClose={() => dispatch(hideSnackbar())}
        severity={severity}
        variant="filled"
        sx={{
          width: '100%',
          fontWeight: 600,
          // Glass oscuro + acento por severidad (borde izquierdo + ícono).
          color: '#F0EDE6',
          bgcolor: alpha('#0E1411', 0.92),
          backdropFilter: 'blur(12px)',
          WebkitBackdropFilter: 'blur(12px)',
          border: `1px solid ${alpha(accent, 0.4)}`,
          borderLeft: `3px solid ${accent}`,
          borderRadius: 2.5,
          boxShadow: `0 16px 40px rgba(0,0,0,0.5), 0 0 0 1px ${alpha(accent, 0.08)}`,
          '& .MuiAlert-icon': { color: accent, opacity: 1 },
          '& .MuiAlert-action .MuiIconButton-root': { color: 'rgba(240,237,230,0.6)' },
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
}
